import {PlayerPositionEnum} from "modules/enums";

export const playerPositions: Record<string, string> = {
	[PlayerPositionEnum.QB]: "player.position.QB",
	[PlayerPositionEnum.WR]: "player.position.REC",
	[PlayerPositionEnum.RB]: "player.position.RB",
	[PlayerPositionEnum.OL]: "player.position.OL",
	[PlayerPositionEnum.DL]: "player.position.DL",
	[PlayerPositionEnum.LB]: "player.position.LB",
	[PlayerPositionEnum.DB]: "player.position.DB",
	[PlayerPositionEnum.K]: "player.position.K",
	[PlayerPositionEnum.P]: "player.position.P",
	[PlayerPositionEnum.ST]: "player.position.ST",
};
